function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import composeClasses from '@mui/utils/composeClasses';
import { getDataGridUtilityClass } from '@mui/x-data-grid';
import { useGridRegisterPipeProcessor } from '@mui/x-data-grid/internals';
import { GRID_REORDER_COL_DEF } from "./gridRowReorderColDef.js";
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes;
    return React.useMemo(function() {
        var slots = {
            rowReorderCellContainer: [
                'rowReorderCellContainer'
            ],
            columnHeaderReorder: [
                'columnHeaderReorder'
            ]
        };
        return composeClasses(slots, getDataGridUtilityClass, classes);
    }, [
        classes
    ]);
};
export var useGridRowReorderPreProcessors = function(privateApiRef, props) {
    var ownerState = {
        classes: props.classes
    };
    var classes = useUtilityClasses(ownerState);
    var updateReorderColumn = React.useCallback(function(columnsState) {
        var reorderColumn = _extends({}, GRID_REORDER_COL_DEF, {
            cellClassName: classes.rowReorderCellContainer,
            headerClassName: classes.columnHeaderReorder,
            headerName: privateApiRef.current.getLocaleText('rowReorderingHeaderName')
        });
        var shouldHaveReorderColumn = props.rowReordering;
        var haveReorderColumn = columnsState.lookup[reorderColumn.field] != null;
        if (shouldHaveReorderColumn && haveReorderColumn) {
            columnsState.lookup[reorderColumn.field] = _extends({}, reorderColumn, columnsState.lookup[reorderColumn.field]);
            return columnsState;
        }
        if (shouldHaveReorderColumn && !haveReorderColumn) {
            columnsState.lookup[reorderColumn.field] = reorderColumn;
            columnsState.orderedFields = [
                reorderColumn.field
            ].concat(_to_consumable_array(columnsState.orderedFields));
        } else if (!shouldHaveReorderColumn && haveReorderColumn) {
            delete columnsState.lookup[reorderColumn.field];
            columnsState.orderedFields = columnsState.orderedFields.filter(function(field) {
                return field !== reorderColumn.field;
            });
        }
        return columnsState;
    }, [
        privateApiRef,
        classes,
        props.rowReordering
    ]);
    useGridRegisterPipeProcessor(privateApiRef, 'hydrateColumns', updateReorderColumn);
};
